/**
 * Centralized logo asset configuration
 * Uses the bundled Quantis SVG so web branding stays aligned with the app.
 */

import quantisLogo from '../assets/Quantis.svg';

const LOGO_URLS = {
  logoFullLight: quantisLogo,
  logoFullDark: quantisLogo,
  logoIconLight: quantisLogo,
  logoIconDark: quantisLogo,
};

/* ─── Get logo URLs (sync, returns immediately) ───────────────────────────── */
export function getLogos() {
  return LOGO_URLS;
}

/* ─── Get cached logos (backward compatibility) ───────────────────────────── */
export function getCachedLogos() {
  return LOGO_URLS;
}

/* ─── Named exports for direct access ─────────────────────────────────────── */
export function getLogoFullLight(): string {
  return LOGO_URLS.logoFullLight;
}

export function getLogoFullDark(): string {
  return LOGO_URLS.logoFullDark;
}

export function getLogoIconLight(): string {
  return LOGO_URLS.logoIconLight;
}

export function getLogoIconDark(): string {
  return LOGO_URLS.logoIconDark;
}

// Legacy named exports - now return default URLs immediately
export const LOGO_FULL_LIGHT = LOGO_URLS.logoFullLight;
export const LOGO_FULL_DARK = LOGO_URLS.logoFullDark;
export const LOGO_ICON_LIGHT = LOGO_URLS.logoIconLight;
export const LOGO_ICON_DARK = LOGO_URLS.logoIconDark;
